import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { SettingsPage } from '../settings/settings';
import { InvitePage } from '../invite/invite';
import { GroupViewPage } from '../group-view/group-view';
import { GroupPermissionsPage } from '../group-permissions/group-permissions';
import { MyInfoPage } from '../my-info/my-info';
import { ContactsPage } from '../contacts/contacts';
import { GroupsPage } from '../groups/groups';


@Component({
  selector: 'page-tabs-controller',
  templateUrl: 'tabs-controller.html'
})
export class TabsControllerPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  tab1Root: any = MyInfoPage;
  tab2Root: any = ContactsPage;
  tab3Root: any = GroupsPage;
  tab4Root: any = InvitePage;
  tab5Root: any = SettingsPage;
  constructor(public navCtrl: NavController) {
  }
  goToSettings(params){
    if (!params) params = {};
    this.navCtrl.push(SettingsPage);
  }goToInvite(params){
    if (!params) params = {};
    this.navCtrl.push(InvitePage);
  }goToGroupView(params){
    if (!params) params = {};
    this.navCtrl.push(GroupViewPage);
  }goToGroupPermissions(params){
    if (!params) params = {};
    this.navCtrl.push(GroupPermissionsPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs-controller/tabs-controller.ts